const KEY = 'et_tracking';

const formatCity = (raw) => {
  if (!raw) return '';
  return decodeURIComponent(raw)
    .replace(/[-+_]/g, ' ')
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
};

const detectCanale = (params, referrer) => {
  const src = (params.get('utm_source') || '').toLowerCase();
  const medium = (params.get('utm_medium') || '').toLowerCase();
  if (params.get('fbclid') || ['facebook', 'fb', 'instagram', 'ig', 'meta'].includes(src)) return 'meta_ads';
  if (params.get('gclid') || params.get('gbraid') || params.get('wbraid') || (src === 'google' && ['cpc', 'ppc', 'paid'].includes(medium))) return 'google_ads';
  if (src) return src;
  if (referrer) {
    try {
      const host = new URL(referrer).hostname;
      if (host.includes(window.location.hostname)) return null;
      if (/google|bing|yahoo|duckduckgo/.test(host)) return 'organico';
      if (/facebook|instagram|fb\.me/.test(host)) return 'meta_organico';
      return 'referral';
    } catch { return 'diretto'; }
  }
  return 'diretto';
};

export const captureTracking = () => {
  const params = new URLSearchParams(window.location.search);
  const existing = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  const cittaParam = formatCity(params.get('citta') || params.get('city') || '');
  const hasNewSignals = params.get('utm_source') || params.get('fbclid') || params.get('gclid') || params.get('gbraid') || params.get('wbraid');

  if (existing && !hasNewSignals) {
    if (cittaParam && cittaParam !== existing.citta) {
      existing.citta = cittaParam;
      sessionStorage.setItem(KEY, JSON.stringify(existing));
    }
    return existing;
  }

  const canale = detectCanale(params, document.referrer);
  const data = {
    canale: canale || (existing && existing.canale) || 'diretto',
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
    citta: cittaParam || (existing && existing.citta) || '',
  };
  sessionStorage.setItem(KEY, JSON.stringify(data));
  return data;
};

export const getTracking = () => {
  const stored = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  return stored || captureTracking();
};

export const getCitta = () => getTracking().citta || '';

export const getLeadTrackingFields = () => {
  const t = getTracking();
  return {
    canale: t.canale || 'diretto',
    utmSource: t.utmSource || '',
    utmMedium: t.utmMedium || '',
    utmCampaign: t.utmCampaign || '',
    citta: t.citta || '',
    pagina: window.location.href,
  };
};
